import React, { useMemo } from 'react';
import { StatCard } from '@onward-delivery/design';

import { NOT_SHIPPER_BOOKABLE, NOT_SHIPPER_BOOKABLE_HINT, fleetStats } from './utils';

const StatCards = ({ resources }) => {
    const stats = useMemo(() => fleetStats(resources), [resources]);

    return (
        <div className="grid shrink-0 grid-cols-2 gap-4 pb-4 md:grid-cols-3">
            <StatCard variant="metric" tone="primary" label="Resources" value={stats.total} />
            {/* Not an error — a resource with no ceiling is schedulable, it just cannot be metered,
                so the calendar has no percentage to show for it. */}
            <StatCard variant="metric" tone="warning" label="No ceilings set" value={stats.noCeilings} />
            {/* Also not an error — with no subregion, shippers cannot book the resource through
                availability, but it still runs routes on the Plan page. */}
            <StatCard
                variant="metric"
                tone="default"
                label={NOT_SHIPPER_BOOKABLE}
                value={stats.noSubregion}
                title={NOT_SHIPPER_BOOKABLE_HINT}
            />
        </div>
    );
};

export default StatCards;
